var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiRecycle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6416 9.97781L13.6663 13.4522C13.2791 14.1423 12.5601 14.5034 11.8332 14.4552H10.253V16.0601L8.27763 12.4492L10.253 8.83839V10.4432H12.4811L10.727 7.35394L14.1483 5.34792L15.5705 7.85143C15.9814 8.46929 16.0367 9.29577 15.6416 9.97781ZM5.6781 0.0600586H9.62875C10.4031 0.0600586 11.0747 0.517431 11.3986 1.1754L12.1888 2.57159L13.5557 1.76919L11.4698 5.3078L7.40058 5.38002L8.76751 4.57761L7.65343 2.61171L5.90724 5.70098L2.47808 3.69496L3.90031 1.19145C4.22426 0.525455 4.89587 0.0600586 5.6781 0.0600586ZM2.39116 13.4603L0.415839 9.98584C0.0286757 9.30379 0.0839849 8.48533 0.486951 7.86748L1.27708 6.47932L-0.0898438 5.67691L3.97142 5.7411L6.06526 9.28774L4.69834 8.48533L3.58426 10.4432H7.09243V14.4552H4.24797C3.8778 14.4825 3.50753 14.4036 3.17929 14.2277C2.85104 14.0518 2.57798 13.7859 2.39116 13.4603Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiRecycle);
export default __webpack_public_path__ + "static/media/mdi_recycle.a0159e9db3d73e96feac2e4b6fdf9ed7.svg";
export { ForwardRef as ReactComponent };